module.exports = __webpack_public_path__ + "img/logo.8b6de868.png";